"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class File {
    constructor() {
        this.mimeType = "";
        this.path = "";
        this.url = null;
        this.metadata = null;
    }
    static is(arg) {
        if (arg instanceof Object) {
            return Object.keys(arg).length === 4 &&
                arg.hasOwnProperty('mimeType') &&
                arg.hasOwnProperty('path') &&
                arg.hasOwnProperty('url') &&
                arg.hasOwnProperty('metadata');
        }
        else {
            return false;
        }
    }
    static from(data) {
        const file = new File();
        file._set(data);
        return file;
    }
    _set(data) {
        this.mimeType = data.mimeType;
        this.path = data.path;
        this.url = data.url;
        this.metadata = data.metadata;
    }
    data() {
        return {
            mimeType: this.mimeType,
            path: this.path,
            url: this.url,
            metadata: this.metadata
        };
    }
}
exports.File = File;
//# sourceMappingURL=File.js.map